<template>
  <CommonNoticeCard
    :class="[b()]"
  >
    <div
      slot="title"
      :class="b('title')"
      v-html="title"
    />
    <template #actions>
      <el-button
        type="plaintext2"
        @click.stop="continueEdit"
      >
        {{ $t('edit.button.continueEdit') }}
      </el-button>
    </template>
  </CommonNoticeCard>
</template>

<script>

import BatchUpdateNoticeCard from './BatchUpdateNoticeCard';
export default {
  name: 'AgGridBatchUpdateNoticeCard',
  components: {},
  extends:BatchUpdateNoticeCard
};
</script>

